var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-general-insights" }, [
    _c(
      "div",
      { staticClass: "insights-container" },
      [
        _c("div", { staticClass: "header-container" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("automation.insightsPage.title"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-container" },
            [
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t(
                          "automation.insightsPage.selectAutomation"
                        ),
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons filter-icon" }, [
                        _vm._v("settings_suggest"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        placeholder: _vm.$t(
                          "automation.insightsPage.selectAutomation"
                        ),
                        allowClear: true,
                      },
                      on: { change: _vm.handleAutomationChange },
                      model: {
                        value: _vm.filters.automationId,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "automationId", $$v)
                        },
                        expression: "filters.automationId",
                      },
                    },
                    _vm._l(_vm.automations, function (automation) {
                      return _c(
                        "a-select-option",
                        {
                          key: automation._id,
                          attrs: { value: automation._id },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(automation.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t("automation.insightsPage.dateRange"),
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons filter-icon" }, [
                        _vm._v("date_range"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("a-range-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "DD/MM/YYYY",
                      placeholder: [
                        _vm.$t("automation.insightsPage.datePlaceholderStart"),
                        _vm.$t("automation.insightsPage.datePlaceholderEnd"),
                      ],
                      ranges: _vm.dateRangePresets,
                    },
                    on: { change: _vm.handleDateChange },
                    model: {
                      value: _vm.filters.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "dateRange", $$v)
                      },
                      expression: "filters.dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t("automation.insightsPage.statusFilter"),
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons filter-icon" }, [
                        _vm._v("filter_list"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t(
                          "automation.insightsPage.statusFilter"
                        ),
                      },
                      on: { change: _vm.handleStatusChange },
                      model: {
                        value: _vm.filters.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "status", $$v)
                        },
                        expression: "filters.status",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "scheduled" } }, [
                        _c("div", { staticClass: "status-option" }, [
                          _c(
                            "i",
                            {
                              staticClass:
                                "material-icons status-icon scheduled",
                            },
                            [_vm._v("schedule")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "automation.insightsPage.statusScheduled"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "running" } }, [
                        _c("div", { staticClass: "status-option" }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons status-icon running",
                            },
                            [_vm._v("play_arrow")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("automation.insightsPage.statusRunning")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "waiting-reply" } },
                        [
                          _c("div", { staticClass: "status-option" }, [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons status-icon waiting",
                              },
                              [_vm._v("hourglass_empty")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.insightsPage.statusWaitingReply"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "done" } }, [
                        _c("div", { staticClass: "status-option" }, [
                          _c(
                            "i",
                            { staticClass: "material-icons status-icon done" },
                            [_vm._v("check_circle")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("automation.insightsPage.statusDone")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "failed" } }, [
                        _c("div", { staticClass: "status-option" }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons status-icon failed",
                            },
                            [_vm._v("error")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("automation.insightsPage.statusFailed")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "cancelled" } }, [
                        _c("div", { staticClass: "status-option" }, [
                          _c(
                            "i",
                            {
                              staticClass:
                                "material-icons status-icon cancelled",
                            },
                            [_vm._v("cancel")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "automation.insightsPage.statusCancelled"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasActiveFilters()
                ? _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t("automation.insightsPage.clearFilters"),
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "clear-filters-button",
                          on: { click: _vm.clearAllFilters },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("clear_all"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: {
                    title: _vm.$t("automation.insightsPage.refreshData"),
                  },
                },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "refresh-button",
                      attrs: { type: "primary" },
                      on: { click: _vm.refreshData },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("refresh"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.hasActiveFilters()
          ? _c("div", { staticClass: "active-filters-bar" }, [
              _c("div", { staticClass: "active-filter-info" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("filter_alt"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("automation.insightsPage.activeFilters"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "active-filters-tags" },
                [
                  _vm.filters.automationId
                    ? _c(
                        "a-tag",
                        {
                          attrs: { closable: "", color: "blue" },
                          on: { close: _vm.clearAutomationFilter },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("settings_suggest"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.getSelectedAutomationName())),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasDateFilter()
                    ? _c(
                        "a-tag",
                        {
                          attrs: { closable: "", color: "green" },
                          on: { close: _vm.clearDateFilter },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("date_range"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.formatDateRange()))]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filters.status, function (status) {
                    return _c(
                      "a-tag",
                      {
                        key: status,
                        attrs: {
                          closable: "",
                          color: _vm.getStatusColor(status),
                        },
                        on: {
                          close: function () {
                            return _vm.removeStatus(status)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.getStatusIcon(status))),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.getStatusName(status)))]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-spin",
          { attrs: { spinning: _vm.loading } },
          [
            _c(
              "div",
              { staticClass: "stats-cards" },
              [
                _c(
                  "a-card",
                  {
                    staticClass: "stats-card",
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "card-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("task_alt"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("automation.insightsPage.totalTasks")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(_vm.insightData.stats.totalTasks)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("automation.insightsPage.executedTasks")
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-card",
                  {
                    staticClass: "stats-card",
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "card-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("horizontal_rule"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "automation.insightsPage.successRate"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatPercentage(
                              _vm.insightData.stats.successRate
                            )
                          ) + "%"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("automation.insightsPage.successfulTasks")
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-card",
                  {
                    staticClass: "stats-card",
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "card-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("timer"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "automation.insightsPage.avgDuration"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatDuration(
                              _vm.insightData.stats.avgDuration
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("automation.insightsPage.avgWorkDuration")
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-card",
                  {
                    staticClass: "stats-card",
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "card-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("pending"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "automation.insightsPage.activeTasks"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(
                              _vm.insightData.stats.totalRunningTasks
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(_vm.$t("automation.insightsPage.runningNow"))
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-container" },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-card",
                          {
                            staticClass: "chart-card",
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "card-title" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("timeline")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "automation.insightsPage.dailyTaskExecution"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chart" },
                              [
                                _c("v-chart", {
                                  attrs: {
                                    options: _vm.dailyTasksOptions,
                                    autoresize: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-card",
                          {
                            staticClass: "chart-card",
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "card-title" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("pie_chart")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "automation.insightsPage.statusDistribution"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chart" },
                              [
                                _c("v-chart", {
                                  attrs: {
                                    options: _vm.statusDistributionOptions,
                                    autoresize: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-container" },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-card",
                          {
                            staticClass: "chart-card",
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "card-title" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("timer")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "automation.insightsPage.durationDistribution"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chart" },
                              [
                                _c("v-chart", {
                                  attrs: {
                                    options: _vm.durationDistributionOptions,
                                    autoresize: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-card",
                          {
                            staticClass: "chart-card",
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "card-title" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("error_outline")]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "automation.insightsPage.terminateReasons"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chart" },
                              [
                                _c("v-chart", {
                                  attrs: {
                                    options: _vm.terminateReasonsOptions,
                                    autoresize: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-card",
              {
                staticClass: "data-table-card",
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "card-title" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("leaderboard"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "automation.insightsPage.automationPerformance"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c("a-table", {
                  attrs: {
                    columns: _vm.automationPerformanceColumns,
                    "data-source": _vm.automationPerformanceData,
                    pagination: { pageSize: 10 },
                    rowKey: function (record) {
                      return record.automationId
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var record = ref.record
                        return [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewAutomationDetails(
                                    record.automationId
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("automation.insightsPage.view")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }